import { render, staticRenderFns } from "./StockCombobox.vue?vue&type=template&id=4b5e09cc&scoped=true"
import script from "./StockCombobox.vue?vue&type=script&lang=js"
export * from "./StockCombobox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5e09cc",
  null
  
)

export default component.exports